import type { PropsWithChildren } from "react";

import { useEffect } from "react";

import type { AlaffiaClient } from "@alaffia-technology-solutions/client-sdk";

import type { QueryClient } from "@tanstack/react-query";

import { QueryClientProvider } from "@tanstack/react-query";

import { AlaffiaClientContext } from "./AlaffiaClient.context";

interface ClientSDKReactQueryProviderProps extends PropsWithChildren {
  alaffiaClient: AlaffiaClient;
  queryClient: QueryClient;
}

export const ClientSDKReactQueryProvider = ({
  alaffiaClient,
  queryClient,
  children,
}: ClientSDKReactQueryProviderProps) => {
  useEffect(() => {
    const subscription = alaffiaClient.auth.loginStatus.subscribe(
      (loginStatus) => {
        const eventType = loginStatus.data?.type;
        if (
          eventType === "LogoutEvent" ||
          eventType === "SessionExpiredEvent"
        ) {
          queryClient.clear();
        } else if (eventType === "LoginSuccessResult") {
          void queryClient.invalidateQueries();
        }
      },
    );

    return () => subscription.unsubscribe();
  }, [alaffiaClient, queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      <AlaffiaClientContext value={{ alaffiaClient }}>
        {children}
      </AlaffiaClientContext>
    </QueryClientProvider>
  );
};
